module.exports = __webpack_public_path__ + "static/testi-5-b9a975cb33bb9bed2c3236af3791d566.jpg";